import { render, staticRenderFns } from "./DoctorListDropdown.vue?vue&type=template&id=ac0b84d0&scoped=true&lang=pug&"
import script from "./DoctorListDropdown.vue?vue&type=script&lang=js&"
export * from "./DoctorListDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DoctorListDropdown.vue?vue&type=style&index=0&id=ac0b84d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0b84d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VMenu,VSheet,VTextField})
